import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@mui/material/Tooltip';
import {AiOutlineFileZip} from 'react-icons/ai';

let DescargarZIPButton = (props) => {
    return (
        <Tooltip title="Descargar Carpeta">
            <IconButton
                aria-label="Add"
                onClick={() => props.onClick()}
            >
                <AiOutlineFileZip />
            </IconButton>
        </Tooltip>
    );
}

export default DescargarZIPButton;

  

